import React from 'react';
import PropTypes from 'prop-types';
import { TableCell, TableRow, Typography, Box, Button } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import WarningIcon from '@material-ui/icons/Warning';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import CancelIcon from '@material-ui/icons/Cancel';
import AccessTimeIcon from '@material-ui/icons/AccessTime';
import VisibilityIcon from '@material-ui/icons/Visibility';
import { formatCnpj } from '@brazilian-utils/formatters';
import { PendenciasTableRowStyles } from '../Pendencias.style';

const useRowStyles = makeStyles(PendenciasTableRowStyles);

const STATUS_CONFIG = {
  AGUARDANDO_VALIDACAO: {
    label: 'Aguardando Validação',
    styleKey: 'statusAguardando',
    Icon: AccessTimeIcon,
  },
  APROVADA: {
    label: 'Aprovado',
    styleKey: 'statusAprovada',
    Icon: CheckCircleIcon,
  },
  RECUSADA: {
    label: 'Rejeitado',
    styleKey: 'statusRecusada',
    Icon: CancelIcon,
  },
  COM_PENDENCIA: {
    label: 'Com Pendência',
    styleKey: 'statusPendencia',
    Icon: WarningIcon,
  },
  VALIDACAO_INTERNA: {
    label: 'Validação Interna',
    styleKey: 'statusValidacaoInterna',
    Icon: AccessTimeIcon,
  },
};

function StatusChip({ status }) {
  const classes = useRowStyles();
  const config = STATUS_CONFIG[status] || STATUS_CONFIG.AGUARDANDO_VALIDACAO;
  const { label, styleKey, Icon } = config;

  return (
    <span className={`${classes.statusChip} ${classes[styleKey]}`}>
      <Icon style={{ fontSize: '14px' }} />
      {label}
    </span>
  );
}

export function PendenciasTableRow({ rowData, onVerDetalhes }) {
  const classes = useRowStyles();

  const formattedDate = rowData.updatedAt ? new Date(rowData.updatedAt).toLocaleDateString('pt-BR') : '-';

  return (
    <TableRow className={classes.tr}>
      <TableCell width="40%">
        <Typography variant="body2">{rowData.partnerName}</Typography>
        <Box display="flex" component="span">
          <Typography variant="caption" className={classes.cnpjCaption}>
            {rowData.cnpj ? formatCnpj(rowData.cnpj) : '-'}
          </Typography>
        </Box>
      </TableCell>

      <TableCell width="20%">
        <StatusChip status={rowData.status} />
      </TableCell>

      <TableCell width="10%">
        <Typography className={classes.tableCell} variant="body2">
          {rowData.activityType || '-'}
        </Typography>
      </TableCell>

      <TableCell width="20%">
        <Typography className={classes.tableCell} variant="body2">
          {formattedDate}
        </Typography>
      </TableCell>

      <TableCell width="10%" align="right">
        <Button
          size="small"
          variant="text"
          color="primary"
          startIcon={<VisibilityIcon />}
          onClick={() => onVerDetalhes(rowData)}
        >
          Ver
        </Button>
      </TableCell>
    </TableRow>
  );
}

PendenciasTableRow.propTypes = {
  rowData: PropTypes.shape({
    partnerId: PropTypes.string,
    partnerName: PropTypes.string,
    cnpj: PropTypes.string,
    activityType: PropTypes.string,
    status: PropTypes.string,
    totalDocuments: PropTypes.number,
    updatedAt: PropTypes.string,
  }).isRequired,
  onVerDetalhes: PropTypes.func.isRequired,
};
